import { hubspotOnboardingApis } from '@shared/apis';
import { genericMutation, genericQuery } from './generics';

export const useListHubspotOnboardingRuns =
  genericQuery<hubspotOnboardingApis.ListHubspotOnboardingRuns>(
    hubspotOnboardingApis.listHubspotOnboardingRuns
  );

export const useScanHubspotOnboarding =
  genericMutation<hubspotOnboardingApis.ScanHubspotOnboarding>(
    hubspotOnboardingApis.scanHubspotOnboarding,
    hubspotOnboardingApis.listHubspotOnboardingRuns.endpoint
  );

export const useImportHubspotOnboardingDeal =
  genericMutation<hubspotOnboardingApis.ImportHubspotOnboardingDeal>(
    hubspotOnboardingApis.importHubspotOnboardingDeal,
    hubspotOnboardingApis.listHubspotOnboardingRuns.endpoint
  );
